import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, EditaCadastraEndereco } from './types';

export const INITIAL_STATE: EditaCadastraEndereco = {
	status: 0,
	data: null,
};

export default function editarCadastrarEnderecoCartao(
	state = INITIAL_STATE,
	action: ReducerAction,
): EditaCadastraEndereco {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EDITA_CADASTRA_ENDERECO: {
				break;
			}

			case Types.EDITA_CADASTRA_ENDERECO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EDITA_CADASTRA_ENDERECO_FAILURE: {
				draft.status = 400;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.LIMPAR_EDITA_CADASTRA_ENDERECO: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
